"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var e = require('styled-components');
var reactToggleGroup = require('@radix-ui/react-toggle-group');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var e__default = /*#__PURE__*/_interopDefaultLegacy(e);

var t=e__default["default"](reactToggleGroup.Root)`
  display: inline-flex;
  border: 1px solid var(--border-input-default);
  background-color: var(--border-input-default);
  border-radius: 6px;
  gap: 1px;
  box-sizing: border-box;
  width: ${o=>o.$iconOnly?"auto":"100%"};
  isolation: isolate;

  & > Button {
    width: ${o=>o.$iconOnly?"42px":"auto"};
    height: ${o=>o.$iconOnly?"42px":"auto"};
    padding: ${o=>o.$iconOnly?"0":"var(--spacing-small) var(--spacing-regular)"};
  }
`,n=e__default["default"](reactToggleGroup.Item)`
  all: unset;
  color: var(--foreground-secondary);
  display: flex;
  font-size: 15px;
  line-height: 1;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  box-sizing: border-box;
  background-color: var(--background-level-1);
  flex: 1;

  &:first-of-type {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  &:hover {
    background-color: var(--background-default-base);
    color: var(--foreground-primary);
    outline: 1px solid var(--border-input-hover);

    > p {
      color: var(--foreground-primary);
    }
  }

  &[data-state='on'] {
    background-color: var(--background-info-base);
    z-index: 2;
    color: var(--foreground-boolean-active);

    > p {
      color: var(--foreground-boolean-active);
    }
  }

  &:focus {
    outline: 2px solid var(--border-link-focus);
    z-index: 3;
  }

  &:disabled {
    color: var(--foreground-disabled);
  }

  // add space between icon and text working in both directions
  svg + p,
  p + svg {
    margin-left: var(--spacing-small);
  }
`;var l=({children:o,...r})=>jsxRuntime.jsx(n,{...r,children:o});l.displayName="SegmentedControlItem";var i=l;var d=({iconOnly:o,children:r,...p})=>jsxRuntime.jsx(t,{$iconOnly:o,...p,children:r});d.displayName="SegmentedControl";var a=d;var c={Item:i,Root:a};

exports.a = c;
